export const formatDateToISOString = (dateString, isStartOfDay = true) => {
  const date = new Date(dateString);

  if (isStartOfDay) {
    date.setUTCHours(0, 0, 0, 0);
  } else {
    date.setUTCHours(23, 59, 59, 999);
  }

  return date.toISOString();
};

export const selectCustomStyle = {
  control: (base, state) => ({
    ...base,
    width: "100%",
    minHeight: "40px",
    backgroundColor: "white",
    borderColor: "#e5e7eb",
    boxShadow: "none",
    "&:hover": {
      borderColor: "#e5e7eb",
    },
    cursor: "pointer",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#9CA3AF",
    "&:hover": {
      color: "#9CA3AF",
    },
  }),
  menu: (base) => ({
    ...base,
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    borderRadius: "6px",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? "#F3F4F6" : "white",
    color: "black",
    cursor: "pointer",
    "&:active": {
      backgroundColor: "#F3F4F6",
    },
  }),
}

export const isEmptyObject = (object) => {
  return Object.keys(object).length === 0;
}
